// Capacitor App.getInfo()를 통해 빌드 버전 라벨을 반환하는 훅
// Android: build.gradle의 versionName(versionCode) → "v1.1.23(7)"
// Web/Electron: 빈 문자열 (표시하지 않음)

import { useEffect, useState } from "react"
import { App } from "@capacitor/app"
import { Capacitor } from "@capacitor/core"

/** Capacitor 네이티브 환경에서 "v{version}({build})" 형식의 빌드 버전 라벨을 반환 */
export function useAppVersion(): string {
  const [label, setLabel] = useState("")

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    App.getInfo()
      .then(info => setLabel(`v${info.version}(${info.build})`))
      .catch(() => {})
  }, [])

  return label
}
